import Create from './create'
import Edit from './edit'

export { Create, Edit }



// WEBPACK FOOTER //
// ./src/pages/widgets/fb-competition/index.js